import { BaseAPI } from "../base/service";
import { Auth, Register } from "./dto";

export class AuthAPI extends BaseAPI {
    public async authenticate(username: string, password: string): Promise<Auth> {
        return await this.api.post('login/', {
            username,
            password,
        })
    }

    public async create(fullname: string, email: string, phone:string, cpf:string): Promise<Register> {
        return await this.api.post('create/', {
            fullname,
            email,
            phone,
            cpf
        })
    }
}
